
































import Vue from "vue";
import storeHelper from "../../../store/store-helper";
import draggable from "vuedraggable";
import { FavoritePatch } from "@infoland/iprova-api";
import CreateHyperlink from "../../dialogs/CreateHyperlink.vue";
import ZenyaDialog from "../../../components/dialogs/ZenyaDialog.vue";
import { ZenyaDialogComponent, ZenyaDialogInjects } from "../../dialogs/ZenyaDialog.vue";
export default ZenyaDialogComponent.extend({
    inject: ZenyaDialogInjects,
    name: "ViewFavorites",
    components: { ZenyaDialog, draggable, CreateHyperlink },
    data: function () {
        return {
            selectedItem: true,
            items: null
        };
    },
    async created() {
        await this.reloadFavorites();
    },
    methods: {
        setFavoriteItems() {
            let itemsToShow = [];
            if (storeHelper.favoriteItemsStore.currentFavorites && storeHelper.favoriteItemsStore.currentFavorites.length > 0) {
                itemsToShow = storeHelper.favoriteItemsStore.currentFavorites;
                itemsToShow = itemsToShow.map(rcItem => ({
                    id: rcItem.favorite_id,
                    title: rcItem.description
                }));
            }
            this.items = itemsToShow;
        },
        async reloadFavorites() {
            await storeHelper.favoriteItemsStore.loadFavorites();
            this.setFavoriteItems();
        },
        editFav: function (item) {
            this.$emit("open-edit-favorite", item);
        },
        async deleteFav(item) {
            const confirmationName = this.$t("portal.portals.favorites.confirmationName").toString().toLocaleLowerCase();
            const confirmed: boolean = await this.$confirm(
                this.$t(`portal.portals.favorites.deleteFavorite`).toString(),
                this.$t("confirmationMessages.delete", {
                    n: confirmationName
                }).toString()
            );

            if (confirmed) {
                let result = await storeHelper.favoriteItemsStore.deleteFavorite(item.id);
                if (result) {
                    await this.reloadFavorites();
                }
            }
        },
        itemOrderChanged: async function (event) {
            const favoriteId = event.moved.element.id;
            const favoriteTitle = event.moved.element.title;
            const newIndex = event.moved.newIndex;
            const oldIndex = event.moved.oldIndex;
            const favoritePath = {
                order: newIndex
            };
            await storeHelper.favoriteItemsStore.updateFavorite(favoriteId, favoritePath as FavoritePatch);
        }
    }
});
